export const mexicoStates = [
  { id: 1, name: "Aguascalientes", iso2: "MX-AGU", code: "AGU", slug: "aguascalientes" },
  { id: 2, name: "Baja California", iso2: "MX-BCN", code: "BCN", slug: "baja-california" },
  { id: 3, name: "Baja California Sur", iso2: "MX-BCS", code: "BCS", slug: "baja-california-sur" },
  { id: 4, name: "Campeche", iso2: "MX-CAM", code: "CAM", slug: "campeche" },
  { id: 5, name: "Chiapas", iso2: "MX-CHP", code: "CHP", slug: "chiapas" },
  { id: 6, name: "Chihuahua", iso2: "MX-CHH", code: "CHH", slug: "chihuahua" },
  { id: 7, name: "Ciudad de México", iso2: "MX-CMX", code: "CMX", slug: "ciudad-de-mexico" },
  { id: 8, name: "Coahuila", iso2: "MX-COA", code: "COA", slug: "coahuila" },
  { id: 9, name: "Colima", iso2: "MX-COL", code: "COL", slug: "colima" },
  { id: 10, name: "Durango", iso2: "MX-DUR", code: "DUR", slug: "durango" },
  { id: 11, name: "Estado de México", iso2: "MX-MEX", code: "MEX", slug: "estado-de-mexico" },
  { id: 12, name: "Guanajuato", iso2: "MX-GUA", code: "GUA", slug: "guanajuato" },
  { id: 13, name: "Guerrero", iso2: "MX-GRO", code: "GRO", slug: "guerrero" },
  { id: 14, name: "Hidalgo", iso2: "MX-HID", code: "HID", slug: "hidalgo" },
  { id: 15, name: "Jalisco", iso2: "MX-JAL", code: "JAL", slug: "jalisco" },
  { id: 16, name: "Michoacán", iso2: "MX-MIC", code: "MIC", slug: "michoacan" },
  { id: 17, name: "Morelos", iso2: "MX-MOR", code: "MOR", slug: "morelos" },
  { id: 18, name: "Nayarit", iso2: "MX-NAY", code: "NAY", slug: "nayarit" },
  { id: 19, name: "Nuevo León", iso2: "MX-NLE", code: "NLE", slug: "nuevo-leon" },
  { id: 20, name: "Oaxaca", iso2: "MX-OAX", code: "OAX", slug: "oaxaca" },
  { id: 21, name: "Puebla", iso2: "MX-PUE", code: "PUE", slug: "puebla" },
  { id: 22, name: "Querétaro", iso2: "MX-QUE", code: "QUE", slug: "queretaro" },
  { id: 23, name: "Quintana Roo", iso2: "MX-ROO", code: "ROO", slug: "quintana-roo" },
  { id: 24, name: "San Luis Potosí", iso2: "MX-SLP", code: "SLP", slug: "san-luis-potosi" },
  { id: 25, name: "Sinaloa", iso2: "MX-SIN", code: "SIN", slug: "sinaloa" },
  { id: 26, name: "Sonora", iso2: "MX-SON", code: "SON", slug: "sonora" },
  { id: 27, name: "Tabasco", iso2: "MX-TAB", code: "TAB", slug: "tabasco" },
  { id: 28, name: "Tamaulipas", iso2: "MX-TAM", code: "TAM", slug: "tamaulipas" },
  { id: 29, name: "Tlaxcala", iso2: "MX-TLA", code: "TLA", slug: "tlaxcala" },
  { id: 30, name: "Veracruz", iso2: "MX-VER", code: "VER", slug: "veracruz" },
  { id: 31, name: "Yucatán", iso2: "MX-YUC", code: "YUC", slug: "yucatan" },
  { id: 32, name: "Zacatecas", iso2: "MX-ZAC", code: "ZAC", slug: "zacatecas" },
];